// extracted by mini-css-extract-plugin
module.exports = {"thiefGame":"ThiefGame_thiefGame__ZLAlz","iframe":"ThiefGame_iframe__3fzSR"};